import React, { useRef, useState } from "react";

const ContactUs = () => {
  const form = useRef();
  const [loading, setLoading] = useState(false);
  const [statusMessage, setStatusMessage] = useState("");
  const [isSuccess, setIsSuccess] = useState(false);

  const sendEmail = (e) => {
    e.preventDefault();

    if (!window.emailjs) {
      setIsSuccess(false);
      setStatusMessage("Email service is not loaded. Please try again.");
      return;
    }

    setLoading(true);
    setStatusMessage("");
    setIsSuccess(false);

    window.emailjs
      .sendForm(
        "service_j8o964h",
        "template_4r2ezfr",
        form.current
      )
      .then(
        function () {
          setLoading(false);
          setIsSuccess(true);
          setStatusMessage("Your message has been sent successfully.");
          form.current.reset();
        },
        function (error) {
          setLoading(false);
          setIsSuccess(false);
          setStatusMessage("Something went wrong. Please try again.");
          console.error("EmailJS error:", error);
        }
      );
  };

  return (
    <section id="contact-us" className="contact-us py-5">
      <div className="container">
        <div className="text-center mb-4">
          <h2>Contact Us</h2>
          <p>
            Give us a call or send us an email and we will get back to you as
            soon as possible
          </p>
        </div>

        <form
          ref={form}
          onSubmit={sendEmail}
          className="mx-auto"
          style={{ maxWidth: "700px" }}
        >
          <input
            type="text"
            name="full_name"
            placeholder="Full Name"
            className="form-control mb-3"
            required
          />

          <input
            type="email"
            name="email"
            placeholder="Email"
            className="form-control mb-3"
            required
          />

          <input
            type="text"
            name="phone"
            placeholder="Phone"
            className="form-control mb-3"
            required
          />

          <input
            type="text"
            name="subject"
            placeholder="Subject"
            className="form-control mb-3"
            required
          />

          <textarea
            name="message"
            placeholder="Message"
            className="form-control mb-3"
            rows="8"
            required
          ></textarea>

          <button
            type="submit"
            className="btn btn-warning px-4"
            disabled={loading}
          >
            {loading ? "Sending..." : "Send"}
          </button>

          {statusMessage && (
            <p
              style={{
                marginTop: "15px",
                color: isSuccess ? "green" : "red",
                fontWeight: "500"
              }}
            >
              {statusMessage}
            </p>
          )}
        </form>
      </div>
    </section>
  );
};

export default ContactUs;
